import type { HintItem, HintKind } from '@/types'

export const HINT_KIND_META: Record<HintKind, { title: string, description: string }> = {
    native: { title: 'بومی', description: 'قابلیت استاندارد Confluence، بدون نیاز به افزونه' },
    addon: { title: 'افزونه', description: 'نیازمند نصب افزونه از Marketplace یا قابلیت نسخه‌های بالاتر' },
    alternative: { title: 'جایگزین بومی', description: 'راهکار جایگزین با امکانات پایه در صورت نبود افزونه' }
}

/** Implementation notes shown on each section when the Confluence guide mode is on. */
export const HINTS: Record<string, HintItem[]> = {
    'header-search': [
        { name: 'Quick Search', kind: 'native' },
        { name: 'Livesearch', kind: 'native' }
    ],
    'sidebar-nav': [
        { name: 'Space Shortcuts', kind: 'native' },
        { name: 'Page Tree', kind: 'native' }
    ],
    'hero': [
        { name: 'Section & Column', kind: 'native' },
        { name: 'Image', kind: 'native' },
        { name: 'Create from Template', kind: 'native' }
    ],
    'home-categories': [
        { name: 'Panel', kind: 'native' },
        { name: 'Section & Column', kind: 'native' },
        { name: 'شمارش خودکار', kind: 'addon' }
    ],
    'home-latest': [
        { name: 'Content by Label', kind: 'native' },
        { name: 'Excerpt', kind: 'native' },
        { name: 'مرتب‌سازی بازدید', kind: 'addon' }
    ],
    'home-popular': [
        { name: 'Content by Label · km-featured', kind: 'native' },
        { name: 'آمار بازدید', kind: 'addon' }
    ],
    'home-lessons': [
        { name: 'Page Properties Report', kind: 'native' }
    ],
    'faq': [
        { name: 'Expand', kind: 'native' },
        { name: 'Excerpt Include', kind: 'native' }
    ],
    'home-contribute': [
        { name: 'Panel', kind: 'native' },
        { name: 'Create from Template', kind: 'native' }
    ],
    'article-meta': [
        { name: 'Page Properties', kind: 'native' },
        { name: 'Status', kind: 'native' }
    ],
    'article-actions': [
        { name: 'Save for later', kind: 'native' },
        { name: 'Share', kind: 'native' }
    ],
    'article-summary': [
        { name: 'Excerpt', kind: 'native' },
        { name: 'Info Panel', kind: 'native' }
    ],
    'article-toc': [
        { name: 'Table of Contents', kind: 'native' }
    ],
    'article-steps': [
        { name: 'Task List', kind: 'native' }
    ],
    'article-diagram': [
        { name: 'draw.io', kind: 'addon' },
        { name: 'Image', kind: 'alternative' }
    ],
    'article-tips': [
        { name: 'Tip Panel', kind: 'native' }
    ],
    'article-pitfalls': [
        { name: 'Expand', kind: 'native' }
    ],
    'article-references': [
        { name: 'Attachments', kind: 'native' },
        { name: 'Page Link', kind: 'native' }
    ],
    'article-history': [
        { name: 'Page History', kind: 'native' }
    ],
    'article-related': [
        { name: 'Content by Label', kind: 'native' },
        { name: 'Related Labels', kind: 'native' }
    ],
    'article-feedback': [
        { name: 'Like', kind: 'native' },
        { name: 'بازخورد صفحه', kind: 'addon' }
    ],
    'article-comments': [
        { name: 'Comments', kind: 'native' }
    ],
    'article-suggest': [
        { name: 'Inline Comments', kind: 'native' }
    ],
    'article-review': [
        { name: 'Status', kind: 'native' },
        { name: 'Restrictions', kind: 'native' },
        { name: 'گردش تأیید', kind: 'addon' }
    ],
    'search': [
        { name: 'Search + CQL', kind: 'native' },
        { name: 'Livesearch', kind: 'native' }
    ],
    'search-facets': [
        { name: 'فیلتر برچسب در CQL', kind: 'native' },
        { name: 'Table Filter', kind: 'addon' }
    ],
    'categories': [
        { name: 'Spaces', kind: 'native' },
        { name: 'Children Display', kind: 'native' }
    ],
    'category-list': [
        { name: 'Content by Label', kind: 'native' },
        { name: 'Page Tree', kind: 'native' }
    ],
    'labels-cloud': [
        { name: 'Popular Labels', kind: 'native' }
    ],
    'contributors': [
        { name: 'Contributors', kind: 'native' }
    ],
    'new-form': [
        { name: 'Create from Template', kind: 'native' },
        { name: 'Template Variables', kind: 'native' },
        { name: 'فرم چندمرحله‌ای', kind: 'addon' }
    ],
    'new-types': [
        { name: 'Page Templates', kind: 'native' }
    ],
    'new-access': [
        { name: 'Restrictions', kind: 'native' }
    ],
    'new-draft': [
        { name: 'Drafts', kind: 'native' }
    ],
    'me': [
        { name: 'CQL · creator = currentUser()', kind: 'native' },
        { name: 'Drafts', kind: 'native' }
    ],
    'saved': [
        { name: 'Save for later', kind: 'native' },
        { name: 'Favourite Pages', kind: 'native' }
    ],
    'lessons': [
        { name: 'Page Properties Report', kind: 'native' },
        { name: 'km-type-lesson', kind: 'native' }
    ],
    'learning-paths': [
        { name: 'Children Display', kind: 'native' },
        { name: 'Task List', kind: 'native' },
        { name: 'Task Report', kind: 'native' }
    ],
    'learning-content': [
        { name: 'Content by Label', kind: 'native' },
        { name: 'Multimedia', kind: 'native' }
    ],
    'profile-card': [
        { name: 'User Profile', kind: 'native' }
    ],
    'profile-stats': [
        { name: 'Contributors Summary', kind: 'native' },
        { name: 'آمار بازدید', kind: 'addon' }
    ],
    'profile-activity': [
        { name: 'Recently Updated', kind: 'native' }
    ]
}

export type SpacePlan = {
    key: string
    title: string
    purpose: string
    access: string
}

export const SPACE_PLAN: SpacePlan[] = [
    { key: 'KM', title: 'پورتال مدیریت دانش', purpose: 'صفحه اصلی سامانه، راهنمای استفاده، پرسش‌های پرتکرار و قالب‌های سراسری', access: 'مشاهده: همه کارکنان؛ ویرایش: تیم مدیریت دانش' },
    { key: 'TECH', title: 'دانش فنی و تخصصی', purpose: 'معماری نرم‌افزار، زیرساخت و شبکه، توسعه نرم‌افزار و امنیت اطلاعات', access: 'مشاهده و ایجاد: کارکنان فنی؛ انتشار: مالک حوزه' },
    { key: 'PROC', title: 'دانش فرایندی و سازمانی', purpose: 'فرایندهای کاری، دستورالعمل‌ها و رویه‌های اجرایی', access: 'مشاهده: همه کارکنان؛ ایجاد: مالکان فرایند' },
    { key: 'PROJ', title: 'دانش پروژه‌ای', purpose: 'مستندات، تجربیات و درس‌آموخته‌های پروژه‌ها', access: 'مشاهده: همه کارکنان؛ صفحات حساس با محدودیت صفحه' },
    { key: 'LEARN', title: 'آموزش و یادگیری', purpose: 'مسیرهای یادگیری، محتوای آموزشی و آموزش ابزارها', access: 'مشاهده: همه کارکنان؛ ایجاد: تیم آموزش و مدرسان' },
    { key: 'ANLY', title: 'دانش تحلیلی و مدیریتی', purpose: 'گزارش‌های تحلیلی، مطالعات تخصصی و مستند تصمیمات', access: 'مشاهده: مدیران و تحلیلگران؛ محدودیت در سطح فضا' },
    { key: 'INNO', title: 'نوآوری و بهبود', purpose: 'ایده‌ها، پیشنهادها و راهکارهای بهبود', access: 'مشاهده و ایجاد: همه کارکنان' }
]

export const LABEL_CONVENTIONS = [
    { pattern: 'km-type-*', example: 'km-type-guide، km-type-lesson', usage: 'نوع دانش؛ مبنای فیلتر نوع، قالب‌ها و گزارش درس‌آموخته‌ها' },
    { pattern: 'km-unit-*', example: 'km-unit-payments، km-unit-security', usage: 'واحد سازمانی؛ مبنای فیلتر واحد در جست‌وجو' },
    { pattern: 'km-featured', example: 'km-featured', usage: 'دانش منتخب تیم مدیریت دانش؛ بخش پرکاربرد صفحه اصلی' },
    { pattern: 'برچسب موضوعی', example: 'api، امنیت، شاپرک', usage: 'موضوع دانش؛ مبنای جست‌وجو و دانش‌های مرتبط. بدون فاصله و با خط تیره' }
]

export const PROPERTY_FIELDS = [
    'نوع دانش',
    'دسته‌بندی و زیرمجموعه',
    'واحد سازمانی',
    'مالک دانش',
    'سطح محرمانگی',
    'وضعیت (ماکرو Status)',
    'تاریخ بازبینی بعدی'
]

export const TEMPLATE_SECTIONS: Record<string, string[]> = {
    'guide': ['خلاصه مدیریتی', 'هدف و دامنه کاربرد', 'پیش‌نیازها', 'شرح دانش', 'مراحل اجرا', 'نکات تخصصی', 'خطاهای رایج و راهکارها', 'منابع'],
    'instruction': ['خلاصه', 'دامنه کاربرد', 'پیش‌نیازها', 'مراحل اجرا', 'مسیر تشدید', 'خطاهای رایج', 'منابع'],
    'lesson': ['خلاصه تجربه', 'زمینه پروژه', 'مسئله یا چالش', 'راهکار ارائه‌شده', 'نتیجه و دستاورد', 'توصیه‌ها'],
    'training': ['هدف آموزشی', 'مخاطب و پیش‌نیاز', 'سرفصل‌ها', 'ویدئو یا ارائه', 'تمرین', 'منابع تکمیلی'],
    'project-doc': ['معرفی پروژه', 'نمای کلی معماری', 'تصمیمات کلیدی', 'وابستگی‌ها', 'منابع'],
    'research': ['خلاصه مدیریتی', 'روش بررسی', 'یافته‌ها', 'پیشنهادها', 'منابع'],
    'qa': ['پرسش', 'پاسخ کوتاه', 'توضیح تکمیلی', 'منابع مرتبط']
}

export type PageMapping = {
    page: string
    href: string
    rows: {
        part: string
        feature: string
        kind: HintKind
        note: string
    }[]
}

export const PAGE_MAPPINGS: PageMapping[] = [
    {
        page: 'صفحه اصلی',
        href: '/',
        rows: [
            { part: 'نوار جست‌وجو', feature: 'Livesearch', kind: 'native', note: 'با پارامتر فضا و برچسب، در بالای صفحه اصلی فضای KM' },
            { part: 'بخش معرفی و دکمه‌ها', feature: 'Section & Column، Image، Create from Template', kind: 'native', note: 'دکمه ثبت دانش به قالب‌های فضای مقصد متصل می‌شود' },
            { part: 'کارت‌های دسته‌بندی', feature: 'Panel در ستون‌ها، پیوند فضا', kind: 'native', note: 'عدد مستندات با به‌روزرسانی دوره‌ای دستی یا افزونه گزارش‌گیری' },
            { part: 'تازه‌ترین دانش‌ها', feature: 'Content by Label با نمایش Excerpt', kind: 'native', note: 'مرتب‌سازی بر اساس تاریخ ایجاد یا ویرایش' },
            { part: 'تب پربازدیدترین', feature: 'Analytics یا افزونه گزارش‌گیری', kind: 'addon', note: 'جایگزین: فهرست منتخب با برچسب km-featured' },
            { part: 'دانش‌های پرکاربرد', feature: 'Content by Label (km-featured)', kind: 'native', note: 'انتخاب و به‌روزرسانی ماهانه توسط تیم مدیریت دانش' },
            { part: 'درس‌آموخته‌ها', feature: 'Page Properties Report', kind: 'native', note: 'ستون‌های چالش، راهکار و نتیجه از جدول ویژگی‌های صفحه' },
            { part: 'پرسش‌های پرتکرار', feature: 'Expand', kind: 'native', note: 'پاسخ‌ها با Excerpt Include از صفحه پرسش‌ها خوانده می‌شوند' }
        ]
    },
    {
        page: 'دسته‌بندی و فهرست دانش‌ها',
        href: '/categories',
        rows: [
            { part: 'هر دسته‌بندی', feature: 'یک فضا (Space) با صفحه اصلی اختصاصی', kind: 'native', note: 'زیرمجموعه‌ها صفحات والد درخت صفحات هستند' },
            { part: 'فهرست زیرمجموعه‌ها', feature: 'Children Display', kind: 'native', note: 'با نمایش خلاصه هر صفحه' },
            { part: 'فهرست دانش‌های حوزه', feature: 'Content by Label', kind: 'native', note: 'محدود به فضای همان حوزه' },
            { part: 'مشارکت‌کنندگان فعال', feature: 'Contributors', kind: 'native', note: 'محدود به فضای حوزه' },
            { part: 'برچسب‌های پرکاربرد', feature: 'Popular Labels', kind: 'native', note: 'در سطح سایت یا فضا' }
        ]
    },
    {
        page: 'جست‌وجوی دانش',
        href: '/search',
        rows: [
            { part: 'جست‌وجوی متنی و پیشنهاد هنگام تایپ', feature: 'Quick Search و صفحه جست‌وجوی بومی', kind: 'native', note: 'فیلترهای فضا، مشارکت‌کننده، تاریخ و نوع محتوا' },
            { part: 'فیلتر نوع دانش و واحد', feature: 'برچسب‌های km-type و km-unit در CQL', kind: 'native', note: 'مثال: label = km-type-guide AND space = TECH' },
            { part: 'فیلتر پویا روی گزارش‌ها', feature: 'Table Filter', kind: 'addon', note: 'جایگزین: جست‌وجوی پیشرفته بومی' }
        ]
    },
    {
        page: 'صفحه جزئیات دانش',
        href: '/knowledge/api-design-standard',
        rows: [
            { part: 'اطلاعات تکمیلی و وضعیت', feature: 'Page Properties و Status', kind: 'native', note: 'منبع داده همه گزارش‌های تجمیعی' },
            { part: 'خلاصه مدیریتی', feature: 'Excerpt درون Info Panel', kind: 'native', note: 'در فهرست‌ها و نتایج نمایش داده می‌شود' },
            { part: 'فهرست مطالب', feature: 'Table of Contents', kind: 'native', note: 'بر اساس سرفصل‌های صفحه' },
            { part: 'مراحل اجرا', feature: 'Task List یا فهرست شماره‌دار', kind: 'native', note: '' },
            { part: 'نمودارها', feature: 'draw.io', kind: 'addon', note: 'جایگزین: تصویر پیوست‌شده با ماکرو Image' },
            { part: 'نکات و خطاهای رایج', feature: 'Tip Panel و Expand', kind: 'native', note: '' },
            { part: 'پیوست‌ها و منابع', feature: 'Attachments و پیوند صفحه', kind: 'native', note: '' },
            { part: 'تاریخچه نسخه‌ها', feature: 'Page History', kind: 'native', note: 'مقایسه و بازگشت به نسخه قبلی' },
            { part: 'دانش‌های مرتبط', feature: 'Content by Label', kind: 'native', note: 'بر اساس برچسب‌های مشترک' },
            { part: 'آیا مفید بود؟', feature: 'Like', kind: 'native', note: 'بازخورد ساختاریافته با افزونه بازخورد صفحه' },
            { part: 'نظرات و پیشنهاد اصلاح', feature: 'Comments و Inline Comments', kind: 'native', note: '' },
            { part: 'علاقه‌مندی و اشتراک', feature: 'Save for later و Share', kind: 'native', note: '' }
        ]
    },
    {
        page: 'ثبت دانش جدید',
        href: '/new',
        rows: [
            { part: 'انتخاب نوع دانش', feature: 'Create from Template و Page Templates', kind: 'native', note: 'هفت قالب، یکی برای هر نوع دانش' },
            { part: 'فیلدهای اطلاعات پایه', feature: 'Template Variables', kind: 'native', note: 'در ویرایشگر Data Center؛ مقادیر در Page Properties درج می‌شوند' },
            { part: 'فرم چندمرحله‌ای با اعتبارسنجی', feature: 'افزونه فرم مانند ConfiForms', kind: 'addon', note: 'جایگزین: قالب با متن راهنما و ویژگی‌های صفحه' },
            { part: 'کلمات کلیدی', feature: 'Labels', kind: 'native', note: '' },
            { part: 'پیوست‌ها', feature: 'Attachments', kind: 'native', note: '' },
            { part: 'سطح محرمانگی', feature: 'Restrictions', kind: 'native', note: 'به همراه فیلد سطح محرمانگی در Page Properties' },
            { part: 'پیش‌نویس', feature: 'Drafts', kind: 'native', note: '' },
            { part: 'ارسال برای بررسی', feature: 'Status، Restrictions و Task برای بازبین', kind: 'native', note: 'گردش تأیید چندمرحله‌ای با افزونه مدیریت سند' }
        ]
    },
    {
        page: 'درس‌آموخته‌ها، آموزش و پروفایل',
        href: '/lessons',
        rows: [
            { part: 'کارت‌های درس‌آموخته', feature: 'Page Properties Report', kind: 'native', note: 'فیلتر با برچسب km-type-lesson' },
            { part: 'مسیرهای یادگیری', feature: 'Children Display', kind: 'native', note: 'هر مسیر یک صفحه والد با صفحات فرزند مرتب' },
            { part: 'پیشرفت شخصی', feature: 'Task List و Task Report', kind: 'native', note: 'نسخه شخصی مسیر از قالب ایجاد می‌شود' },
            { part: 'ویدئوهای آموزشی', feature: 'Multimedia', kind: 'native', note: 'پخش فایل پیوست‌شده در صفحه' },
            { part: 'کارت پروفایل', feature: 'User Profile', kind: 'native', note: '' },
            { part: 'فعالیت‌های اخیر', feature: 'Recently Updated با فیلتر نویسنده', kind: 'native', note: '' },
            { part: 'آمار بازدید', feature: 'Analytics یا افزونه گزارش‌گیری', kind: 'addon', note: 'جایگزین: نمایش تعداد دانش‌ها با Page Properties Report' },
            { part: 'علاقه‌مندی‌ها', feature: 'Save for later', kind: 'native', note: '' }
        ]
    }
]

export const ADDONS = [
    { name: 'draw.io Diagrams', purpose: 'نمودارهای معماری و فرایند قابل ویرایش در صفحه', fallback: 'تصویر پیوست‌شده با ماکرو Image' },
    { name: 'ConfiForms یا Forms for Confluence', purpose: 'فرم چندمرحله‌ای ثبت دانش با اعتبارسنجی', fallback: 'قالب صفحه با متغیرهای قالب و متن راهنما' },
    { name: 'Comala Document Management', purpose: 'گردش تأیید چندمرحله‌ای و ثبت سابقه تأیید', fallback: 'ماکرو Status، محدودیت صفحه و Task برای بازبین' },
    { name: 'Table Filter, Charts & Spreadsheets', purpose: 'فیلتر پویا روی گزارش‌های Page Properties', fallback: 'جست‌وجوی بومی با CQL و برچسب‌ها' },
    { name: 'Analytics یا افزونه گزارش‌گیری', purpose: 'آمار بازدید، پربازدیدترین‌ها و شمارش خودکار', fallback: 'فهرست منتخب با برچسب km-featured و حذف عدد' },
    { name: 'Refined یا Scroll Viewport', purpose: 'پوسته و ناوبری اختصاصی پورتال', fallback: 'Stylesheet سراسری و میانبرهای فضا در Data Center' }
]

export const WORKFLOW = [
    { title: 'پیش‌نویس', status: 'grey', description: 'صفحه با قالب ایجاد شده و فقط برای نویسنده قابل مشاهده است.' },
    { title: 'در انتظار بررسی', status: 'yellow', description: 'وضعیت در Page Properties تغییر می‌کند و برای مالک حوزه Task ثبت می‌شود.' },
    { title: 'نیازمند اصلاح', status: 'red', description: 'بازبین توضیح خود را به‌صورت نظر ثبت و صفحه را به نویسنده بازمی‌گرداند.' },
    { title: 'منتشرشده', status: 'green', description: 'محدودیت مشاهده برداشته می‌شود و صفحه در گزارش‌ها و جست‌وجو قرار می‌گیرد.' },
    { title: 'بازبینی دوره‌ای', status: 'blue', description: 'در تاریخ بازبینی بعدی، مالک دانش صحت محتوا را تأیید یا آن را به‌روز می‌کند.' }
]

export const RTL_STYLESHEET = `/* Global stylesheet: Confluence Data Center > Look and Feel > Stylesheet */
@font-face {
  font-family: "Vazirmatn";
  src: url("/download/attachments/<pageId>/Vazirmatn-Variable.woff2") format("woff2");
  font-weight: 100 900;
  font-display: swap;
}

#main-content,
.wiki-content {
  direction: rtl;
  text-align: right;
  font-family: "Vazirmatn", Tahoma, sans-serif;
  line-height: 1.9;
}

.wiki-content pre,
.wiki-content code {
  direction: ltr;
  text-align: left;
}`
